import React from "react";
import { useNavigate } from "react-router-dom";
import "./component.css";

export default function BottomBuyButton() {
  const navigate = useNavigate();

  const handleBuyClick = () => {
    navigate("/homepage2"); // make sure this route is defined in your app
  };

  return (
    <div className="buy-now-fixed d-block d-md-none">
      <button className="buy-now-btn w-100" onClick={handleBuyClick}>
        Buy Now
      </button>
    </div>
  );
}
